<template>
    <div>
        <slot :data="cData" :loading="loading" :empty="empty"></slot>
        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
            <!-- <div slot="spinner">Loading...</div> -->
            <error-message slot="no-more" text="主人，没有更多啦~" />
            <div class="empty-bg" slot="no-results">
                <div class="box">
                    <img src="@/assets/shopping-icon/empty.png" alt="">
                    <p>暂无数据哦~</p>
                </div>
            </div>
        </infinite-loading>
    </div>
</template>

<script type="text/javascript">
    import InfiniteLoading from "vue-infinite-loading";
    export default {
        name: "order-scroll",
        data() {
            return {
                height: 0,
                page: 1,
                data: [],
                loading: 0,
                infiniteId: 1,
                btnFlag: false,
            };
        },
        //返回时要修改
        props: {
            limit: {
                type: Number,
                default: 10,
            },
            url: {
                type: String,
                required: true,
            },
            params: {
                type: Object,
                default () {
                    return {};
                },
            },
            computeData: Function,
        },
        computed: {
            sendData() {
                return {
                    ...this.params,
                    page: this.page,
                    //limit: this.limit
                };
            },
            trigger() {
                return this.url + "?" + this.$QueryString.stringify(this.params);
            },
            cData() {
                return (
                    (typeof this.computeData === "function" ?
                        this.computeData(this.data) :
                        this.data) || []
                );
            },
            empty() {
                return !this.cData.length;
            },
        },

        created() {},
        mounted() {},
        methods: {
            norepeat(arr) {
                for (var i = 0; i < arr.length - 1; i++) {
                    for (var j = i + 1; j < arr.length; j++) {
                        if (arr[i].id === undefined) continue;
                        if (arr[i].id == arr[j].id) {
                            arr.splice(j, 1);
                            j--;
                        }
                    }
                }
                return arr;
            },
            infiniteHandler($state) {
                // this.data = [{
                //     id: "13797",
                //     order_num: "202112171129732910",
                //     customer_id: 3,
                //     price: 3.0,
                //     total_price: 3.0,
                //     num: 2,
                //     goods_id: 1,
                //     total_discount_price: 1.5,
                //     create_time: "2021-12-17 09:57:27",
                //     status: "1",
                //     logisticsFlag: true,
                //     goods_name: "商品名称",
                //     detailInfo: {
                //         order_id: 13797,
                //         gift_id: 1,
                //         gift_name: "礼包名称",
                //         type: 2,
                //     },
                //     goodsGroupItem: [{
                //             "id": "245",
                //             "group_id": "203",
                //             "price": "398.00",
                //             "type": "1",
                //             "gift_name": "面膜2盒+颈膜3盒",
                //             "img": "https://tradingimage.3975.com/forum/Uploads/Picture/168428983383720.jpg",
                //             "stock": "1385"
                //         },
                //         {
                //             "id": "246",
                //             "group_id": "204",
                //             "price": "0.00",
                //             "type": "3",
                //             "gift_name": "“有钱就是任性”称号、顶级幻化石*5、超级幻化石*5、顶级英雄碎片*20",
                //             "img": "https://tradingimage.3975.com/forum/Uploads/Picture/168792068282601.png",
                //             "stock": "638"
                //         }
                //     ],
                //     cdk: {
                //         order_id: 13797,
                //         name: "名称",
                //         cdk: ["cdk1", "cdk2"],
                //     },
                // }, ];
                // $state.complete();
                // return
                if (this.url != "") {
                    this.loading++;
                    this.$Ajax(this.url, this.sendData)
                        .then(rs => {
                            this.page++;
                            this.$emit("on-fetch", {
                                data: rs.data.list,
                            });
                            if (
                                rs.code == 200 &&
                                rs.data.list instanceof Array &&
                                rs.data.list.length > 0
                            ) {
                                this.data.push(...rs.data.list);
                                this.data = this.norepeat(this.data)
                                $state.loaded();
                            }
                            if (
                                !rs.data.page_info.totalPage ||
                                rs.data.page_info.page >= rs.data.page_info.totalPage
                            ) {
                                $state.complete();
                            }
                        })
                        .finally(() => {
                            //this.loading--;
                        });
                }
            },
            refresh() {
                this.page = 1;
                this.data = [];
                this.infiniteId++;
            },
        },
        watch: {
            trigger: "refresh",
        },
        components: {
            InfiniteLoading,
        },
    };
</script>

<style lang="less" scoped>
.empty-bg {
    .box {
      margin: 3.25rem 4.1rem 0;
      opacity: 0.83;
      img {
        width: 100%;
        height: 100%;
      }
      p {
        text-align: center;
        opacity: 1;
        color: #000000;
      }
    }
  }
</style>